module.exports = __webpack_public_path__ + "img/38.6af071e2.png";